<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->

  <div id="init-home-container" class="d-flex background_color">
    <v-container class="background_color black--text" id="home-container">
      <template>
        <div class="bcs-expansion-content mt-4">
          <div
            id="big-card"
            class="d-flex justify-center align-center background_color"
          >
            <v-card
              id="home-content-area"
              class="mb-16 pt-4"
              color="grey lighten-5"
              elevation="4"
              outlined
            >
              <v-card elevation="2" shaped class="mt-4 ml-2 mr-2">
                <v-card-title>
                  <h4>
                    To submit a public records request, Click on the link below:
                  </h4>
                </v-card-title>
                <v-card-text>
                  <a
                    href="https://www.reno.gov/government/departments/city-clerk/public-records"
                    target="_blank"
                    >City of Reno Public Records Portal</a
                  >
                  <br />
                  <small
                    >You will be taken away from this page into a new browser
                    tab.</small
                  >
                </v-card-text>
              </v-card>

              <!-- -------------------------------------------------------- -->
              <!-- account creation guide -->
              <v-card
                elevation="2"
                shaped
                class="basic-interior-card pa-4 mt-4"
              >
                <v-layout
                  column
                  justify-center
                  align-center="true"
                  class="mt-4"
                >
                  <v-flex xs12 sm12 md12>
                    <h3>OneRequest Customer User Guide</h3>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <h4>(With Regular Account)</h4>
                  </v-flex>
                </v-layout>

                <v-layout column justify-start align-start class="mt-4">
                  <v-flex xs12 sm12 md12>
                    <p>
                      Website to create/login/obtain public records requests
                      from the City of Reno. Link Above.
                    </p>
                    <!-- <p>
                      <a href="https://reno.streamlinegov.us/" target="_blank"
                        >https://reno.streamlinegov.us/</a
                      >
                    </p> -->

                    <div>
                      <div class="d-flex d-sm-none border-img elevation-3">
                        <v-img
                          src="../images/one_req_landing_mobile_480.png"
                        ></v-img>
                      </div>
                      <div
                        class="d-none d-sm-flex d-md-none border-img elevation-3"
                      >
                        <v-img src="../images/webstreamsite.png"></v-img>
                      </div>
                      <div
                        class="d-none d-md-flex d-lg-none border-img elevation-3"
                      >
                        <v-img src="../images/webstreamsite.png"></v-img>
                      </div>
                      <div class="d-none d-lg-flex border-img elevation-3">
                        <v-img src="../images/webstreamsite_1200.png"></v-img>
                      </div>
                    </div>
                    <div class="mt-8">
                      <h3>Login page</h3>
                      <div
                        class="d-flex row justify-center pa-4 div-login-page-img elevation-3"
                      >
                        <v-img
                          class="login-page-img"
                          src="../images/loginpage.png"
                        ></v-img>
                      </div>
                    </div>
                    <hr />
                    <p class="mt-8">
                      Once the customer logs in they will be taken to the home
                      page where it will show any/all requests they have
                      submitted in OneRequest.<br />
                      lf they need to submit a new request, click on 'New
                      Request'.
                    </p>

                    <div>
                      <div class="d-flex d-sm-none elevation-3">
                        <v-img src="../images/one_reg_landpg_600.png"></v-img>
                      </div>
                      <div class="d-none d-sm-flex elevation-3">
                        <v-img src="../images/onerq_landpage_960.png"></v-img>
                      </div>
                      <!-- <div class="d-none d-md-flex d-lg-none">
                  <v-img src="../images/webstreamsite.png"></v-img>
                </div>
                <div class="d-none d-lg-flex">
                  <v-img src="../images/webstreamsite_1200.png"></v-img>
                </div> -->
                    </div>
                    <hr class="mt-8" />
                    <p class="mt-4">
                      When submitting a new request, they will be asked a series
                      of questions that will route their request to the
                      appropriate department. They will also be able to submit
                      any required and/or supporting documentation.
                    </p>
                    <div>
                      <div class="d-flex d-sm-none elevation-3">
                        <v-img src="../images/new_onerequest_600.png"></v-img>
                      </div>
                      <div class="d-none d-sm-flex elevation-3">
                        <v-img src="../images/new_onerequest_960.png"></v-img>
                      </div>
                      <!-- <div class="d-none d-md-flex d-lg-none">
                  <v-img src="../images/webstreamsite.png"></v-img>
                </div>
                <div class="d-none d-lg-flex">
                  <v-img src="../images/webstreamsite_1200.png"></v-img>
                </div> -->
                    </div>
                    <hr class="mt-8" />
                    <p class="mt-4">
                      Before being allowed to submit their request, the customer
                      must click on 'I agree to the terms and conditions.'
                    </p>
                    <div>
                      <div class="d-flex d-sm-none elevation-3">
                        <v-img src="../images/terms_600.png"></v-img>
                      </div>
                      <div class="d-none d-sm-flex elevation-3">
                        <v-img src="../images/terms_960.png"></v-img>
                      </div>
                      <!-- <div class="d-none d-md-flex d-lg-none">
                  <v-img src="../images/webstreamsite.png"></v-img>
                </div>
                <div class="d-none d-lg-flex">
                  <v-img src="../images/webstreamsite_1200.png"></v-img>
                </div> -->
                    </div>
                    <div
                      class="d-flex row justify-center pa-4 div-login-page-img elevation-3"
                    >
                      <v-img
                        class="login-page-img"
                        src="../images/finish_home_960.png"
                      ></v-img>
                    </div>
                    <hr class="mt-8" />
                    <p class="mt-4">
                      Once the request has been submitted and the customer
                      clicks on “Home” they will be taken back to the home
                      screen where it will show any/all requests they have
                      submitted.
                      <br />
                      Customer will then receive an email stating that their
                      request has been received.
                    </p>
                    <div>
                      <div class="d-flex d-sm-none elevation-3">
                        <v-img src="../images/req_list_600.png"></v-img>
                      </div>
                      <div class="d-none d-sm-flex elevation-3">
                        <v-img src="../images/req_list_960.png"></v-img>
                      </div>
                    </div>

                    <hr class="mt-8" />
                    <p class="mt-4">
                      Customer will then receive an email stating that their
                      request has been received.
                    </p>
                    <div class="mb-8">
                      <div
                        class="d-flex row justify-center pa-1 div-login-page-img"
                      >
                        <v-img
                          class="elevation-3 pa-1 letter_img"
                          src="../images/letter_960.png"
                        ></v-img>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-card>
          </div>
        </div>
      </template>
    </v-container>
    <v-btn
      @click.prevent="fabup"
      class="fabup"
      elevation="2"
      fab
      color="green"
      title="back"
    >
      <v-icon color="black" dark> $arrowLeft </v-icon>
    </v-btn>
  </div>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
.fabup {
  position: fixed;
  left: 85%;
  top: 90%;
  z-index: 500;
}
border-img {
  border: 1px solid black;
}
.div-login-page-img {
  margin: 0;
}
.letter_img {
  width: 100%;
  margin-left: 0 !important;
}
.login-page-img {
  width: 100%;
  margin-left: 0 !important;
}
p {
  font-weight: 600;
  padding: 12px;
}
a {
  color: blue;
}
a:visited {
  color: rgb(2, 2, 32);
}
.bcs-expansion-content {
  color: black;
}
.basic-interior-card {
  min-height: 100px;
  margin: 8px;
}
@media (min-width: 768px) {
  .fabup {
    position: fixed;
    left: 96%;
    top: 90%;
  }
  #home-container {
    width: 100vw;

    height: auto;
    position: relative;
    top: 0px;
  }
  .login-page-img {
    max-width: 300px;
  }
  .letter_img {
    max-width: 436px;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "pub_recs_req",
  mixins: [bus_common],
  data: function () {
    return {
      isActive1: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    fabup() {
      history.back();
    },
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
      var element = document.getElementById("vapp");
      element.style.maxHeight = "450vh";
      element.style.height = "450vh";
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
